export default __webpack_public_path__ + "static/media/note_icon.cd19a334.svg";